/**
 * Zitate Renderer
 * Renders quotes from JSON data
 */

import type { ZitateData, Zitat } from '../../types';

export function renderZitate(data: ZitateData | null): void {
  if (!data?.zitate) return;

  data.zitate.forEach((zitat: Zitat) => {
    // Find quote container by position
    let container: HTMLElement | null = null;
    switch (zitat.position) {
      case 'nach-medienprojekte':
        container = document.getElementById('quote-1');
        break;
      case 'nach-filmproduktionen':
        container = document.getElementById('quote-2');
        break;
      case 'nach-ueber-uns':
        container = document.getElementById('quote-3');
        break;
      case 'nach-begleitmaterial':
        container = document.getElementById('quote-4');
        break;
      case 'nach-gedenkort':
        container = document.getElementById('quote-5');
        break;
      case 'nach-stolpersteine-app':
        container = document.getElementById('quote-6');
        break;
    }

    if (container) {
      const quoteBlock = container.closest('.quote-block');
      if (quoteBlock) {
        // Update quote text
        container.innerHTML = zitat.text;

        // Update author
        const authorEl = quoteBlock.querySelector<HTMLElement>('.quote-block__author');
        if (authorEl) {
          authorEl.textContent = `– ${zitat.autor} (${zitat.funktion})`;
        }

        // Update image if exists
        const imageEl = quoteBlock.querySelector<HTMLImageElement>('.quote-block__image');
        if (imageEl && zitat.bild) {
          imageEl.src = zitat.bild;
          imageEl.alt = zitat.autor;
        }
      }
    }
  });
}
